
  import * as vercelRuntime$_98YP6QQxwbij9hKiMHOqH48mDCv5Bc9F_6Odx9oPPPE from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.11.0_@types+node@20.19.18_@vercel+blob@2.8.0_@vercel+functions@2.2.13_@aw_8e70cb4593c692ff6bc0c60082a0df04/node_modules/@nuxt/image/dist/runtime/providers/vercel'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 360,
    "sm": 414,
    "md": 768,
    "lg": 1366,
    "xl": 1536,
    "xxl": 1536,
    "2xl": 1920
  },
  "presets": {},
  "provider": "vercel",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2,
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "jpeg",
    "jpg",
    "png",
    "gif",
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['vercel']: { provider: vercelRuntime$_98YP6QQxwbij9hKiMHOqH48mDCv5Bc9F_6Odx9oPPPE, defaults: {} }
    }
  }
